import React from 'react';
import {Loading} from 'Components/Partials';

import Unauthenticated from 'Components/Layouts/Unauthenticated';

import {translation} from 'Services/TranslationHelpers';

import AddToCalendar from './AddToCalendar';

export default class AddToCalendarPage extends React.Component {
    /**
     * @var state
     */
    state = {
        loading: true,
        item: this.props.match?.params?.item ?? null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount = async () => {
        this.setState({loading: false});
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render () {
        const {loading, item} = this.state;

        if (item === "1") {
            var event = {
                title: 'S224 Launch Event',
                timezone: 'Europe/London',
                location: window.location.origin,
                startTime: '2023-10-25T09:00Z',
                endTime: '2023-10-25T15:00Z',
                description: 'The S2 2024 launch will take place on the 25th October 2023, please see the registration site for more details',
            };

            var filename = 's2-24-event';
        }

        return (
            <Unauthenticated>
                <div className="w-full">
                    {loading && <Loading />}

                    {!loading && !event &&
                        <p className="text-center">
                            {translation('misc', 'invalid_link')}
                        </p>
                    }

                    {!loading && event &&
                        <AddToCalendar event={event} filename={filename} />
                    }
                </div>
            </Unauthenticated>
        )
    }
};
